
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"currentColor","stroke":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.75.748h6v6h-6zm0 9.75v-.75h1.5m0 4.5H.75v-.75m6 0v.75h-1.5m-3 9H.75v-1.5m6 0v1.5h-1.5m0-13.5h1.5v.75m-6 8.25v-1.5h1.5m3 0h1.5v1.5m8.25-3-3.75 3.75 3.75 3.75","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M11.25 19.5h4.5a7.5 7.5 0 0 0 0-15h-4.5","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    